import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  inject,
} from '@angular/core';
import { COMMUNITY_DEFAULT_AVATAR, DataTestDirective, PassportService, ProfileService, User } from '@outlaw/core';
import { MenuItem, DropdownPosition, MenuDirection } from '../../interfaces';
import { ProfileMenuService } from '../../services/util/profile-menu.service';
import { NgClass } from '@angular/common';
import { getBackwardsUrl } from '../../utils/backwards-url.util';
import { IconComponent } from '@outlaw/icons';

const DEFAULT_DROPDOWN_POSITION: DropdownPosition = {
  closed: 'bottom',
  open: 'top',
};

@Component({
  selector: 'app-login-profile-block',
  templateUrl: './login-profile-block.component.html',
  styleUrls: ['./login-profile-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, DataTestDirective, IconComponent],
})
export class LoginProfileBlockComponent {
  private profileService = inject(ProfileService);
  private passportService = inject(PassportService);
  private elementRef = inject(ElementRef);
  private profileMenuService = inject(ProfileMenuService);

  @Input() showUserMenu = false;
  @Input() dropdownIconPosition: DropdownPosition = DEFAULT_DROPDOWN_POSITION;
  @Input() menuItems: MenuItem[] = this.profileMenuService.getDefaultMenuItems();
  @Input() menuDirection: MenuDirection = 'bottom';
  @Output() toggleUserMenu = new EventEmitter<void>();

  readonly user: User = this.profileService.getUser();
  readonly defaultAvatar = COMMUNITY_DEFAULT_AVATAR;

  get loginLink(): string {
    return this.passportService.getLoginLink(getBackwardsUrl());
  }

  get dropdownIconClass(): string {
    return this.showUserMenu ? this.dropdownIconPosition.open : this.dropdownIconPosition.closed;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const isClickedOutside = !this.elementRef.nativeElement.contains(event.target);

    if (isClickedOutside && this.showUserMenu) {
      this.toggleMenu(event);
    }
  }

  toggleMenu(event: Event): void {
    event.stopPropagation();
    this.toggleUserMenu.emit();
  }

  handleItemClick(item: MenuItem): void {
    if (item.action) {
      item.action();
    }

    if (item.link) {
      window.open(item.link, '_blank');
    }

    this.toggleUserMenu.emit();
  }

  onAvatarError(event: Event): void {
    (event.target as HTMLImageElement).src = this.defaultAvatar;
  }
}
